export default {
    data() {
        return {
            table: '',
            datas: {
                add: {
                }
            }
        };
    },
    created() {
        this.datas.add = {
            ...this.datas.add,
            ...this.$route.query || {}
        };
        this._load();
    },
    methods: {

    },
};